<template>

  <!-- 1st Hero Variation -->
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-2 bg-gradient-default content_background_color_blue2"  >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container ">
      <div class="row">

        <div class=" col-lg-12 justify-content-center">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes=""
                class="border-0">

            <div class="col-md-12 center-block" v-if="is_load_projects==false">
              <sui-segment>
                <sui-dimmer active>
                  <sui-loader size="tiny"></sui-loader>
                </sui-dimmer>


              </sui-segment>
            </div>
            <div class="col-md-12 center-block" v-if="is_load_projects==true">
              <h2>Задачи на сегодня</h2>
            </div>

            <div class="col-md-12 center-block mt-5 mb-2" v-if="is_load_projects==true">




              <div class="col-lg-12" v-if="projects.length>0">

                <div class="row mt-2 card   "
                     v-if=" project_index>=(((projects_table.current_page*projects_table.on_page)-projects_table.on_page)-1) && project_index<=((projects_table.current_page*projects_table.on_page)-1)"
                     v-for="(project,project_index) in projects" :key="project.last_id">
                  <div class="col-lg-12 text-clip">

                    <h5 v-html="project.text_task"></h5>
                    <router-link class="text-clip  "   :to="{name: 'lead', params: { id: project.lead_id }}">
                      <base-button   class="btn side2" >Посмотреть задачу


                      </base-button>
                    </router-link>


                    <p class="mt-2">Дней до дедлайна:<span class="badge badge-danger">{{ project.days}}</span></p>
                    <p class="mt-2">Дедлайн {{ project.date_to}}</p>
                  </div>




                </div>


                <div class="row mt-5">
                  <base-pagination :per-page="projects_table.on_page" :total="projects_table.total"
                                   v-model="projects_table.current_page"></base-pagination>
                </div>


              </div>

            </div>
          </card>
        </div>

      </div>
    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";


export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load_projects": false,
      "projects_table": {
        "current_page": 1,
        "on_page": 30,
        "total": 0,
      },
      "filter":{
        "q":"",
        "type":"projects",
      },
      "statuses": {},

      "current_status": null,
      "iserror": false,
      "error_message": null,
      "form": {
        'json': {},
      },
      "loaded_categorys": false,
      "categorys": null,
      "modal_title": "Создать проект",
      'modals': {
        "add": null,
      },
      "projects": [],
      "filter_projects": [],
      'is_load_chart': false,
      'circle_chart': {
        chartdata: {
          labels: ['Ищут исполнителя', 'В работе', 'Завершено',],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#03acca', '#ff3709', '#1aae6f'],
              data: []
            },

          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    }
  },

  mounted: function () {

    var app = this;

    Api.loadLeadsTasks(function (data) {
      app.filter_projects = data.tasks;
      app.changeStatusFilter();

      app.projects_table.total = app.project.length;
    });





  },
  methods: {
    callModalAddProject() {
      eventBus.$emit("call_modal_add_project", {})
      {

      }
    },
    changeStatusFilter() {
      var app = this;
      var projects = [];
      if (Number.isInteger(app.current_status)) {
        app.projects_table.total = 0;
        var total = 0;
        app.filter_projects.forEach(function callback(currentValue, index, array) {
          //your iterator

            projects.push(currentValue);


        });
        app.projects = projects;
      } else {
        app.projects = app.filter_projects;
      }

      app.projects_table.total = app.projects.length;
      app.is_load_projects = true;
    },





  },
  components: {Modal, CircleChart}
};
</script>